{
  "name": "demo",
  "hostname": "demo.serveport.com",
  "default": null,
  "development": false,
  "production": true,
  "applicationName": "ServePort",
  "sourceVersion": "80522afac79974f23d5210e6c96a9453be900c5b",
  "errors": {
    "numRetries": 3
  },
  "urls": {
    "apiRootCoManage": "https://@.demo.serveport.com/_api/comanage/",
    "apiRootLpms": "https://@.demo.serveport.com/_api/lpms/",
    "apiRootSquirrel": "https://@.demo.serveport.com/_api/squirrel/",
    "apiRootRms": "https://@.demo.serveport.com/_api/rms/"
  },
  "stripe": {
    "key": "pk_test_sXNkfHf4SoQCOwMv6G26jnOd00AaAlGrWM"
  },
  "auth0": {
    "authorityRoot": "safarilaw-demo.auth0.com",
    "clientId": "OiLUAWTLHOxQwhWDA9nFpFZCljiYzyAE",
    "useLocalStorageCache": false
  },
  "auth": {
    "inactivityTimeout": 0,
    "inactivityWarning": 0
  },
  "statusApp": {
    "apiRootUrl": "https://@.demo.serveport.com/_api/maintenance/",
    "code": "4M5ANviM0RwUqsdw1DpfPg5ygi6luDkbARDd22N3x2OfAzFuWH3POw==",
    "cacheDurationInMinutes": 5
  },
  "featureFlags": {
    "demoPreviews": true,
    "devTools": false,
    "devExceptions": false,
    "inputRelativeValidation": true,
    "enableServiceOfProcessBusinessHours": true
  },
  "loggers": {
    "elmah": {
      "apiKey": "752d3d5a800541cd8dd1b5d747cc188a",
      "logId": "b4d08d9d-31b1-46cb-ab06-3f5272c67f6a"
    },
    "appInsights": {
      "connectionString": "InstrumentationKey=8de08394-cda6-438e-9b7e-f15299ae59ff;IngestionEndpoint=https://eastus-2.in.applicationinsights.azure.com/;LiveEndpoint=https://eastus.livediagnostics.monitor.azure.com/;ApplicationId=b6428d4b-e652-458f-a67d-f67bebe8aa24"
    }
  },
  "uiSettings": {
    "hasNavbar": true,
    "list": {
      "maxCountInMemory": 10000,
      "pageSize": 20
    },
    "maxSubtypesToShowInDropdown": 0,
    "updatePollFrequency": 3600,
    "richTextEditor": {
      "initializationTimeoutInMs": 2000
    },
    "file": {
      "tusUploadLimitInMb": 0,
      "maxCorrespondenceSizeAttachmentInMb": 20,
      "previewDialogTimeLimitInSeconds": 5,
      "downloadTarget": "_self"
    },
    "reports": {
      "key": "Z70R-XG6J5I-274219-0W0Y0F-734Y3H-5I460R-0H445W-4F6S27-2G5S1J-4P291I-2E5N"
    }
  },
  "signalR": {
    "hubs": [
      {
        "api": "rms",
        "name": "submissions",
        "url": "signalr/submissions"
      }
    ]
  }
}
